<template>
  <div class="collect-panel">
    <div class="module growth-module">
      <div class="subTit2"><span>作物生长趋势监测</span></div>
      <div class="stats">
        <div class="stat" v-for="item in stats" :key="item.name">
          <span>{{ item.name }}</span>
          <strong>{{ item.value }}</strong>
        </div>
      </div>
      <div class="growth-chart">
        <GrowthTrendChart
          :x-data="iotData.hours"
          :soil-temperature-data="iotData.soilTemperature"
          :soil-moisture-data="iotData.soilMoisture"
        />
      </div>
    </div>
    <div class="module table-module">
      <div class="subTit2"><span>地块生长状态监测</span></div>
      <table>
        <thead>
          <tr>
            <th>地块编号</th>
            <th>作物品种</th>
            <th>生长阶段</th>
            <th>株高cm</th>
            <th>土壤湿度%</th>
            <th>生长判定</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in rows" :key="row.code">
            <td>{{ row.code }}</td>
            <td>{{ row.crop }}</td>
            <td>{{ row.stage }}</td>
            <td>{{ row.height }}</td>
            <td>{{ row.moisture }}</td>
            <td>{{ row.status }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup>
import GrowthTrendChart from "./GrowthTrendChart.vue";

defineProps({
  iotData: {
    type: Object,
    default: () => ({
      hours: [],
      soilTemperature: [],
      soilMoisture: [],
    }),
  },
});

const stats = [
  { name: "生长周期进度", value: "42%" },
  { name: "当前阶段", value: "夏播旺长期" },
  { name: "正常地块", value: "19块" },
  { name: "异常预警", value: "1条" },
];

const rows = [
  { code: "A01", crop: "夏玉米", stage: "拔节期", height: 92, moisture: 48, status: "长势良好" },
  { code: "A03", crop: "花生", stage: "开花下针期", height: 34, moisture: 52, status: "长势良好" },
  { code: "A05", crop: "大豆", stage: "分枝初花期", height: 46, moisture: 45, status: "墒情略低" },
  { code: "A07", crop: "芝麻", stage: "现蕾期", height: 58, moisture: 49, status: "长势平稳" },
  { code: "A09", crop: "红薯", stage: "蔓长期", height: 38, moisture: 54, status: "长势良好" },
];
</script>

<style lang="less" scoped>
.collect-panel {
  height: 100%;
  display: grid;
  grid-template-rows: 1fr 0.82fr;
  gap: 40px;
}

.module {
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.subTit2 {
  width: 100%;
  height: 66px;
  line-height: 20px;
  padding-left: 40px;
  box-sizing: border-box;
  background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/xiaomai/xbt.png") no-repeat left bottom;
  font-size: 30px;
  text-align: left;
  color: rgba(254, 254, 254, 1);
}

.stats {
  height: 104px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 18px;
  padding: 18px 36px 0;
  box-sizing: border-box;
}

.stat {
  border: 1px solid rgba(109, 231, 255, 0.62);
  border-radius: 8px;
  background: linear-gradient(180deg, rgba(24, 112, 132, 0.68), rgba(8, 49, 76, 0.7));
  box-shadow: inset 0 0 20px rgba(85, 226, 255, 0.23);
  color: #dff7ff;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;

  span {
    font-size: 20px;
  }

  strong {
    margin-top: 6px;
    font-size: 32px;
    line-height: 34px;
  }
}

.growth-chart {
  flex: 1;
  min-height: 0;
}

table {
  width: calc(100% - 32px);
  margin: 14px 16px 0;
  border-collapse: collapse;
  color: #dff7ff;
  font-size: 24px;
}

th,
td {
  height: 70px;
  text-align: center;
  border: 1px solid rgba(77, 178, 232, 0.35);
  background: rgba(7, 47, 77, 0.42);
}

th {
  color: #e8fbff;
  font-weight: bold;
  background: rgba(11, 77, 103, 0.68);
}
</style>
